import { contactData } from '@/mocks/homeData';

export default function Footer() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
            <div>
              <span className="text-2xl font-heading font-bold text-background-50 mb-4 block">
                色影视
              </span>
              <p className="text-sm text-secondary-300 leading-relaxed">
                高清免费电影、高清免费电视剧、高清免费综艺大全。超清画质，流畅不缓冲，无需付费注册，每日更新最新热门影视剧集。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a
                  href="#media"
                  onClick={(e) => { e.preventDefault(); scrollToSection('#media'); }}
                  className="text-background-50 hover:text-primary-400 transition-colors no-underline cursor-pointer"
                >
                  快速导航
                </a>
              </h4>
              <ul className="space-y-2.5">
                {[
                  { label: '精彩推荐', href: '#media' },
                  { label: '焦点推荐', href: '#carousel' },
                  { label: '热度榜单', href: '#ranking' },
                  { label: '最新动态', href: '#updates' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                      className="text-sm text-secondary-300 hover:text-primary-400 transition-colors no-underline cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-mail-line text-secondary-400"></i>
                  <span>{contactData.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-wechat-line text-secondary-400"></i>
                  <span>{contactData.wechat}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-qq-line text-secondary-400"></i>
                  <span>{contactData.qq}</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-secondary-300 leading-relaxed">
                诚邀各大影视内容平台、视频技术提供商及媒体合作伙伴加入，共同打造更优质的观影生态。
              </p>
            </div>
          </div>

          <div className="border-t border-secondary-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              &copy; {new Date().getFullYear()} 色影视 - 高清免费电影与高清免费电视剧全集在线观看平台
            </p>
            <p className="text-xs text-secondary-400">
              仅供学习交流，请支持正版影视作品
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}